import React from "react";
import "../Dashboard/dashboard.css";
import RingLoaderShared from "../../shared/RingLoader/RingLoader";

const AdminMF = React.lazy(() => import("ChildAdmin/admin"));

const Managment = () => {
  return (
    <>
      <React.Suspense fallback={<RingLoaderShared />}>
        <AdminMF />
      </React.Suspense>
    </>
  );
};

export default Managment;
